const formatSearchSuggestions = (searchSuggestions) => searchSuggestions.map((suggestion) => ({ title: suggestion }));

export default formatSearchSuggestions;
